import React, { forwardRef } from 'react';
import { FaCalendarAlt } from 'react-icons/fa';

export interface CustomDatepickerInputProps {
    value?: string;
    onClick?: () => void;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    placeholder?: string;
    className: string;
    disabled: boolean;
}

export const CustomDatepickerInput = forwardRef<HTMLInputElement, CustomDatepickerInputProps>(
    ({ value, onClick, onChange, placeholder, className, disabled }, ref) => (
        <div style={{ position: 'relative', width: '100%' }}>
            <input
                disabled={disabled}
                ref={ref}
                type="text"
                value={value !== undefined && value !== null ? value : ''}
                onClick={onClick}
                onChange={onChange}
                placeholder={placeholder}
                className={className}
                style={{
                    paddingRight: '30px', // Space for the icon
                    width: '100%',
                    padding: '8px 12px',
                    borderRadius: '4px',
                    border: '1px solid #ced4da',
                    fontSize: '13px',
                }}
            />
            <FaCalendarAlt
                onClick={onClick}
                style={{
                    position: 'absolute',
                    right: '8px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    cursor: 'pointer',
                    color: '#6c757d',
                }}
            />
        </div>
    )
);
